// Business types for different kinds of websites in the monorepo
export const BUSINESS_TYPES = {
  MUSICIAN: "musician",
  SOFTWARE: "software",
  SERVICE: "service",
  ECOMMERCE: "ecommerce",
  PORTFOLIO: "portfolio",
};

// Feature sets typically associated with each business type
export const BUSINESS_FEATURES = {
  [BUSINESS_TYPES.MUSICIAN]: {
    typical: ["shop", "media", "tour", "gallery", "discography", "awards"],
    dataTypes: ["performance_data", "media_files", "tour_dates", "merchandise"],
  },
  [BUSINESS_TYPES.SOFTWARE]: {
    typical: ["app", "blog", "newsletter", "earlyAccess", "documentation"],
    dataTypes: ["user_data", "app_analytics", "usage_metrics", "preferences"],
  },
  [BUSINESS_TYPES.SERVICE]: {
    typical: ["contact", "booking", "portfolio", "testimonials"],
    dataTypes: ["service_inquiries", "booking_data", "client_information"],
  },
  [BUSINESS_TYPES.ECOMMERCE]: {
    typical: ["shop", "cart", "wishlist", "reviews", "accounts"],
    dataTypes: [
      "order_history",
      "payment_info",
      "shipping_addresses",
      "product_reviews",
    ],
  },
  [BUSINESS_TYPES.PORTFOLIO]: {
    typical: ["gallery", "projects", "contact", "blog"],
    dataTypes: [
      "contact_forms",
      "project_inquiries",
      "newsletter_subscriptions",
    ],
  },
};

// Legal content configurations for different business types
export const LEGAL_CONTENT_CONFIG = {
  [BUSINESS_TYPES.MUSICIAN]: {
    privacySections: [
      "contact_form",
      "local_storage",
      "shop",
      "performance_data",
      "media_gallery",
      "tour_information",
    ],
    termsSections: [
      "intellectual_property",
      "shop_terms",
      "performance_content",
      "media_usage",
    ],
    cookieTypes: [
      {
        id: "essential",
        label: "Essential",
        description: "Required for basic site functionality",
      },
      {
        id: "functional",
        label: "Functional",
        description: "Remember your preferences and shopping cart",
      },
      {
        id: "analytics",
        label: "Analytics",
        description: "Help us understand how visitors use our site",
      },
    ],
  },
  [BUSINESS_TYPES.SOFTWARE]: {
    privacySections: [
      "contact_form",
      "local_storage",
      "app_data",
      "user_accounts",
      "analytics",
      "third_party_services",
    ],
    termsSections: [
      "software_license",
      "user_accounts",
      "acceptable_use",
      "data_ownership",
      "service_availability",
    ],
    cookieTypes: [
      {
        id: "essential",
        label: "Essential",
        description: "Required for app functionality and security",
      },
      {
        id: "functional",
        label: "Functional",
        description: "Remember your app preferences and settings",
      },
      {
        id: "analytics",
        label: "Analytics",
        description: "Help us improve our product",
      },
      {
        id: "marketing",
        label: "Marketing",
        description: "Show relevant product updates and features",
      },
    ],
  },
  [BUSINESS_TYPES.SERVICE]: {
    privacySections: [
      "contact_form",
      "local_storage",
      "service_inquiries",
      "client_data",
    ],
    termsSections: [
      "service_agreement",
      "payment_terms",
      "cancellation_policy",
      "liability_limitations",
    ],
    cookieTypes: [
      {
        id: "essential",
        label: "Essential",
        description: "Required for basic site functionality",
      },
      {
        id: "functional",
        label: "Functional",
        description: "Remember your inquiry details",
      },
    ],
  },
};

// Default business type if not specified
export const DEFAULT_BUSINESS_TYPE = BUSINESS_TYPES.MUSICIAN;
